import React from "react";
import RydHeaderDialogBox from "./widgets/RydHeaderDialogBox";
import { RollRedrawObserver } from "../utils/RollRedrawObserver";
import { TimeSignature } from "../model/core";

function TimeSignatureInputBox({
    timeSignature = new TimeSignature(4, 4),
    setTimeSignatureCB,
    redrawObserver
}: {
    timeSignature?: TimeSignature,
    setTimeSignatureCB?: (timeSignature: TimeSignature) => void,
    redrawObserver?: RollRedrawObserver
}) {
    const [collapsed, setCollapsed] = React.useState(true);

    if (collapsed) {
        return (<button onClick={() => setCollapsed(false)}>{timeSignature.numerator}/{timeSignature.denominator}</button>);
    }

    return (<RydHeaderDialogBox closeCB={() => { setCollapsed(true) }}>
        <>
            <input
                type="number"
                min="1"
                max="99"
                value={timeSignature.numerator}
                onChange={(e) => setTimeSignatureCB?.(new TimeSignature(
                    Number(e.target.value),
                    timeSignature.denominator
                ))}
            />
            /
            <input
                type="number"
                min="4"
                max="64"
                value={timeSignature.denominator}
                onChange={(e) => setTimeSignatureCB?.(new TimeSignature(
                    timeSignature.numerator,
                    Number(e.target.value)
                ))}
            />
        </>
    </RydHeaderDialogBox>);
}

export default TimeSignatureInputBox;